import React from "react";
import { Routes, Route } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";
import fondo from "../../assets/img/fondo.png";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

import VentasLayout from "./VentasLayout";
import VentasPage from "./VentasPage";
import VentasContrato from "./Contrato";

import ContratoParcelas from "./productos/Parcelas";
import ContratoColumbarios from "./productos/Columbarios";
import ContratoNichosAtaud from "./productos/NichosAtaud";

import ContratoCremacion from "./servicios/Cremacion";
import ContratoExequias from "./servicios/Exequia";
import ContratoInhumacion from "./servicios/Inhumacion";
import ContratoFunerario from "./servicios/Funerarios";
import ServicioFunerario from "./servicios/ServicioFunerario";
import ContratoPrevisivos from "./servicios/Previsivos";

import Solicitudes from "./ventas/Solicitudes";
import Contratos from "./ventas/ListaContratos";
import Clientes from "./ventas/Clientes";
import Vendedores from "./ventas/VendedoresList";

import ReportePagos from "./pagos/ReportePagosPage";
import ReportePagosCuotas from "./pagos/ReportePagosCuotas";
import HistorialPagos from "./pagos/HistorialPagos";

import Planes from "./Planes";

import SubirDocumento from "./clientes/SubirDocumento";
import DocumentosFamiliares from "./clientes/DocumentosFamiliares";
import Autorizados from "./AutorizadosPage";

import Ayuda from "../ayuda/Ayuda";
import AyudaGeneral from "../ayuda/AyudaGeneral";

const VentasDashboard = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundImage: `url(${fondo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <CssBaseline />
      <Header />
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <VentasLayout />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            mt: 1,
            p: 1,
            overflow: "auto",
          }}
        >
          <Routes>
            <Route index element={<VentasPage />} />
            <Route path="/planes" element={<Planes />} />
            <Route path="contrato/:producto" element={<VentasContrato />} />
            <Route path="contrato/:producto" element={<ContratoParcelas />} />
            <Route path="contrato/:producto" element={<ContratoCremacion />} />
            <Route path="contrato/:producto" element={<ContratoExequias />} />
            <Route path="contrato/:producto" element={<ContratoInhumacion />} />
            <Route
              path="contrato/:producto"
              element={<ContratoNichosAtaud />}
            />
            <Route path="contrato/previsivo" element={<ContratoPrevisivos />} />
            <Route
              path="contrato/:producto"
              element={<ContratoColumbarios />}
            />
            <Route path="contrato/:producto" element={<ContratoFunerario />} />
            <Route
              path="contrato/servicio-funerario"
              element={<ServicioFunerario />}
            />
            <Route path="/solicitudes" element={<Solicitudes />} />
            <Route path="/contratos" element={<Contratos />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/vendedores" element={<Vendedores />} />
            <Route path="/reporte-pagos" element={<ReportePagos />} />{" "}
            <Route path="/reporte-cuotas" element={<ReportePagosCuotas />} />{" "}
            <Route path="historial-pagos" element={<HistorialPagos />} />
            <Route path="/subir-documento" element={<SubirDocumento />} />
            <Route path="/autorizados" element={<Autorizados />} />
            {/* Nueva ruta */}
            <Route path="ayuda" element={<Ayuda />} />
            <Route path="ayuda/:temaId" element={<AyudaGeneral />} />
          </Routes>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default VentasDashboard;
